import { Component } from '@verndale/core';
import { animate } from 'motion';

class AlertBanner extends Component {
  setupDefaults() {
    this.dom = {
      closeButton: this.el.querySelector<HTMLElement>('.alert-banner__close')
    };
  }

  addListeners() {
    (this.dom.closeButton as HTMLElement)?.addEventListener('click', this.handleClose.bind(this));
  }

  async handleClose() {
    await animate(this.el, { y: '-100%' }, { duration: 0.5 }).finished;
    this.el.remove();
  }
}

export default AlertBanner;
